import React, { useEffect, useState } from 'react'
import ReportHeader from "../../../common/ReportHeader";
import { Box, Divider, Typography } from '@mui/material';
import ExcelAndPrint from '../../../common/ExcelAndPrint';
import VirtualizedTable from '../../../common/VirtualizedTable';
import { inquiryTwoColDef } from '../../Reports/constants';
import { getInquiryAgent2ReportData } from '../../../redux/Report/ReportActions';
import { showErrorAlert } from '../../../redux/Actions';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { decryptText } from '../../../utils/Decrypt';

const InquiryTwoReport = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [searchParams] = useSearchParams();
  const [paramsLoaded, setParamsLoaded] = useState(false);
  let decryptedData = {}
  try {
    const paramData = searchParams.get("data");
    if (paramData) {
      decryptedData = JSON.parse(decryptText(decodeURIComponent(paramData)));
    }
  } catch (error) {
    console.error("Invalid query data:", error);
  }

  const { intAgentID, dtJourneyDate, TripTime } = decryptedData

  useEffect(() => {
    if (searchParams.toString()) {
      setParamsLoaded(true);
    }
  }, [searchParams]);


  const groupData = (apiData = []) => {
    const grouped = apiData.reduce((acc, item) => {
      const key = `${item.TripTime}||${item.RouteName}||${item.JourneyDate}||${item.ChartName}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
    const sortedKeys = Object.keys(grouped).sort((a, b) => {
      const [timeA, routeA, dateA, chartA] = a.split("||");
      const [timeB, routeB, dateB, chartB] = b.split("||");
      if (timeA !== timeB) return timeA.localeCompare(timeB);
      if (routeA !== routeB) return routeA.localeCompare(routeB);
      if (dateA !== dateB) return new Date(dateA) - new Date(dateB);
      return chartA.localeCompare(chartB);
    });
    let tableRows = [];
    sortedKeys.forEach((groupKey) => {
      const firstItem = grouped[groupKey][0];
      const subHeadingText = `${firstItem.TripTime} ${firstItem.RouteName} ${firstItem.JourneyDate} ${firstItem.ChartName}`;
      tableRows.push({
        isSubHeadingRow: true,
        subHeadingData: [{ caption: subHeadingText, colSpan: 10 }],
      });
      grouped[groupKey].forEach((item) => {
        tableRows.push({
          ...item,
          SeatCount: Number(item.TotalSeatsCount || 0),
          TotalFare: Number(item.TotalFare || 0).toFixed(2),
        });
      });
    });

    return tableRows;
  };

  useEffect(() => {
    if (!paramsLoaded) return;
    const requiredFields = [intAgentID, dtJourneyDate];
    const hasError = requiredFields.some(
      (val) => val === undefined || val === null
    );
    if (hasError) {
      dispatch(showErrorAlert("Invalid URL: Missing required parameters"));
      return;
    }
    const body = {
      intAgentID: Number(intAgentID),
      dtJourneyDate: dtJourneyDate,
    };

    dispatch(getInquiryAgent2ReportData(body))
      .then((res) => {
        if (res.data.status) {
          const parsedData = JSON.parse(res.data.Data);
          const updatedData = parsedData.Table
          const data = groupData(updatedData);
          setTableData(data);
        } else {
          dispatch(showErrorAlert(res.data.Message));
        }
      })
      .catch(() => {
        dispatch(showErrorAlert("Failed to load Inquiry2 report"));
      });
  }, [
    paramsLoaded,
    intAgentID,
    dtJourneyDate,
    dispatch,
  ]);
  return (
    <>
      <ReportHeader reportitle="Inquiry2" />
      <Box
        sx={{
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Journey Date: {dtJourneyDate} {TripTime}</Typography>
        <ExcelAndPrint
          reportTitle="Inquiry2"
          multiTable={[
            {
              titleTable: "",
              columnDef: inquiryTwoColDef,
              body: tableData,
            },
          ]}
        />
      </Box>
      <Divider />
      <Box sx={{ padding: "12px 16px" }}>
        <VirtualizedTable
          tableData={tableData}
          columnDefs={inquiryTwoColDef}
        />
      </Box>
    </>
  )
}

export default InquiryTwoReport
